<template>
  <v-container>

    <v-row dense justify="center" align="center">
      <!-- Avatar -->
      <v-col :cols="($vuetify.breakpoint.xsOnly) ? 4 : 2" align-self="center" justify-self="center">
        <patient-avatar-upload v-model="dependent" />
      </v-col>
      <!-- Form -->
      <v-col :cols="($vuetify.breakpoint.xsOnly) ? 12 : 8">
        <dependent-form v-model="dependent" class="pa-5" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const Hashids = require("hashids");
import DependentForm from '@/components/dependents/DependentForm';
import PatientAvatarUpload from '@/components/general/PatientAvatarUpload';

export default {
  data: () => ({
    Hashids: null,
    dependent: null,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.Hashids = new Hashids.default(process.env.VUE_APP_HASHID_SALT, Number(process.env.VUE_APP_HASHID_PAD));

    const { dependent } = this.$route.params;
    if (dependent && Object.entries(dependent).length > 0) {
      this.dependent = dependent;
    } else if (this.$route.params.id) {
      this.getDependent(this.Hashids.decode(this.$route.params.id));
    }
  },
  methods: {
    getDependent(id) {
      this.$store
        .dispatch('patientDependents/one', {
          patientId: this.user.id,
          dependentId: id,
        })
        .then((dependent) => {
          this.dependent = dependent;
        });
    },
  },
  components: {
    DependentForm,
    PatientAvatarUpload,
  },
};
</script>
